import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("canvas", {
    id: "identify-render",
    width: $props.contentWidth,
    height: $props.contentHeight
  }, null, 8, ["width", "height"]);
}